module.exports = __webpack_public_path__ + "img/0Q3A6963_FoamcoreMatted.ba07763d.jpg";